import { useCallback, useMemo } from 'react';

import { NumberParam, useQueryParams, withDefault } from 'use-query-params';

export interface UsePaginationOptions {
  pageSize: number;
}

const defaultOptions: UsePaginationOptions = {
  pageSize: 10,
};

const DefaultPageParam = withDefault(NumberParam, 1);

// TODO @deceptions S2CX-12075: Move to fenrir package
export function usePagination({ pageSize } = defaultOptions) {
  const [queryParams, setQueryParams] = useQueryParams({
    page: DefaultPageParam,
    pageSize: withDefault(NumberParam, pageSize),
  });

  const pagination = useMemo(
    () => ({
      pageIndex: queryParams.page - 1,
      pageSize: queryParams.pageSize,
    }),
    [queryParams],
  );

  const setPagination = useCallback(
    (newPage: number) => {
      setQueryParams({ page: newPage > 0 ? newPage + 1 : undefined });
    },
    [setQueryParams],
  );

  const setPageSize = useCallback(
    (newPageSize: number) => {
      setQueryParams({ pageSize: newPageSize, page: undefined });
    },
    [setQueryParams],
  );

  return [pagination, setPagination, setPageSize] as const;
}
